import { connect } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'
import SignUpModal from 'components/SignUpModal'

const mapStateToProps = (state) => ({
  isOpen: state.modals.signUp.isOpen
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpModal)
